import { TokenStorage } from './TokenStorage';
export class GlobalStorage extends TokenStorage {
    /**
     * Creates a global token storage instance for the given origin
     * A global token storage use a global variable to store the actual origin tokens
     * @param origin
     * @return
     */
    static create(origin) {
        return Promise.resolve(new GlobalStorage(origin, GlobalStorage.tokens[origin]));
    }
    /**
     * @inheritDoc
     */
    saveToken(origin, token, temporary) {
        if (!temporary) {
            if (token) {
                GlobalStorage.tokens[origin] = token;
            }
            else {
                delete GlobalStorage.tokens[origin];
            }
        }
    }
}
GlobalStorage.tokens = {};
TokenStorage.GLOBAL = GlobalStorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2xvYmFsU3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkdsb2JhbFN0b3JhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBRTlDLE1BQU0sT0FBTyxhQUFjLFNBQVEsWUFBWTtJQUc3Qzs7Ozs7T0FLRztJQUNILE1BQU0sQ0FBQyxNQUFNLENBQUMsTUFBYztRQUMxQixPQUFPLE9BQU8sQ0FBQyxPQUFPLENBQUMsSUFBSSxhQUFhLENBQUMsTUFBTSxFQUFFLGFBQWEsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQ2xGLENBQUM7SUFFRDs7T0FFRztJQUNILFNBQVMsQ0FBQyxNQUFjLEVBQUUsS0FBYSxFQUFFLFNBQWtCO1FBQ3pELElBQUksQ0FBQyxTQUFTLEVBQUU7WUFDZCxJQUFJLEtBQUssRUFBRTtnQkFDVCxhQUFhLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxHQUFHLEtBQUssQ0FBQzthQUN0QztpQkFBTTtnQkFDTCxPQUFPLGFBQWEsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUM7YUFDckM7U0FDRjtJQUNILENBQUM7O0FBdkJjLG9CQUFNLEdBQWlDLEVBQUUsQ0FBQztBQTBCM0QsWUFBWSxDQUFDLE1BQU0sR0FBRyxhQUFhLENBQUMifQ==